import { focusFirstChild } from '@fluentui/react';
import { FocusWorker } from './FocusWorker';

export class FirstElementFocusWorker extends FocusWorker {
    protected override scrollToElementCore(): void {
        this._list.current?.scrollToIndex(0);
    }

    protected override focusElement(): void {
        if (!this._root.current) {
            return;
        }

        // The first focusable item is the expand/collapse button; we don't want to focus it.
        // Instead we search for the first menu item.
        const firstListItem = this._root.current.querySelector('[data-list-index="0"]');

        if (firstListItem) {
            // if found, focus on the GroupedComboBoxButton control inside it
            focusFirstChild(firstListItem as HTMLElement);
        } else {
            // if there's no list item, fall back to focusing the expand/collapse button.
            focusFirstChild(this._root.current);
        }
    }

    public onCollapsed(): void {
        if (this._root.current) {
            // when this section is collapsed, we move focus to the toggle button in the header
            focusFirstChild(this._root.current);
        }
    }
}
